import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */

/**
 * Deferred Promise
 */
var Deferred = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Deferred() {
    var _this = this;

    _classCallCheck(this, Deferred);

    this._promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
  }
  /**
   * @returns The {@link Deferred} Promise
   */


  _createClass(Deferred, [{
    key: "promise",
    get: function get() {
      return this._promise;
    }
    /**
     * Rejects this promise
     */

  }, {
    key: "reject",
    value: function reject(reason) {
      this._reject(reason);
    }
    /**
     * Resolves this promise
     */

  }, {
    key: "resolve",
    value: function resolve(value) {
      this._resolve(value);
    }
  }]);

  return Deferred;
}();

export { Deferred as default };